'use strict';

module.exports = function macro(name, fn) {
  this.constructor.prototype[name] = fn;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/collect.js/dist/methods/macro.js
// module id = ./node_modules/collect.js/dist/methods/macro.js
// module chunks = 0